import { useAuthStore } from '@/features/auth/store';

/**
 * Where a "logo" / brand link should point: the landing page for signed-out
 * visitors, otherwise the user's own dashboard — admin console for platform
 * admins, personal dashboard for everyone else. Workspace-context-aware
 * routing (college/company) lives in AppShell's sidebar, which derives it
 * from the currently active section; this hook is for links rendered
 * outside that shell (e.g. the public profile page) where no such context
 * exists, so it falls back to the personal dashboard.
 */
export function useHomeHref(): string {
  const user = useAuthStore((state) => state.user);
  if (!user) return '/';
  if (user.role === 'ADMIN') return '/admin';
  return '/personal/dashboard';
}
